import MuiIconButton, { type IconButtonProps } from '@mui/material/IconButton';

export type { IconButtonProps };

const IconButton = (props: IconButtonProps) => <MuiIconButton {...props} />;

export default IconButton;
